import {
  Button,
  Divider,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  FormControl,
  Grid,
} from "@material-ui/core";
import { getStorage, ref, uploadBytesResumable } from "firebase/storage";
import React, { useEffect, useRef, useState } from "react";
import { useFirebase } from "../../../Firebase/FirebaseContext";
import CustomButton from "../../Buttons/CustomButton";
import moment from "moment";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
} from "firebase/firestore";
import { CloudUpload, VideoLibrary, CheckCircle } from "@material-ui/icons";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import { set } from "date-fns";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 700,
    margin: "0 auto",
    padding: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(4),
    textAlign: "center",
  },
  icon: {
    fontSize: 64,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 20,
    border: `1px solid ${theme.palette.divider}`,
  },
  formSection: {
    marginBottom: theme.spacing(3),
  },
  uploadZone: {
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(4),
    textAlign: "center",
    backgroundColor: theme.palette.background.default,
    transition: "all 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main + "08",
    },
  },
  uploadIcon: {
    fontSize: 48,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  progressContainer: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.default,
  },
  successMessage: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.main,
    marginTop: theme.spacing(2),
  },
}));

export default function UploadVideo() {
  const history = useHistory();
  const { firebase } = useFirebase();
  const classes = useStyles();
  const selectFile = useRef(null);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const fileSelectionClick = () => {
    selectFile.current.click();
  };
  const [upload, setUpload] = useState(false);
  const [progress, setProgress] = useState(0);
  const [sex, setSex] = useState("");
  const [minAge, setMinAge] = useState();
  const [maxAge, setMaxAge] = useState();
  const [disclaimer, setDisclaimer] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const submit = () => {
    if (file && fileName && minAge && maxAge && disclaimer) {
      setUpload(true);
      const storage = getStorage();
      const trimedName = file.name.replace(/\s+/g, "");
      const url = `videos/${trimedName}`;
      const data = {
        title: fileName,
        path: url,
        sex: sex,
        minAge: parseInt(minAge),
        maxAge: parseInt(maxAge),
        createdAt: new Date(),
        laboratoryId: localStorage.currentLab,
      };
      const videoRef = ref(storage, url);
      const uploadTask = uploadBytesResumable(videoRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(Math.trunc(progress));
        },
        (e) => {
          console.log(e);
        },
        () => {
          addDoc(
            collection(
              firebase.db,
              "laboratories/" + localStorage.currentLab + "/videos"
            ),
            data
          )
            .then(() => {
              addDoc(collection(firebase.db, "videos"), {
                title: fileName,
                path: url,
                createdAt: new Date(),
              })
                .then(() => {
                  setUpload(false);
                  enqueueSnackbar("La vidéo a bien été uploadée", {
                    variant: "success",
                  });
                  history.push("/home");
                })
                .catch((e) => console.log(e));
            })
            .catch((e) => console.log(e));
        }
      );
    } else if (!disclaimer) {
      enqueueSnackbar(
        "Veuillez certifier que la vidéo provient d'une source licite",
        {
          variant: "error",
        }
      );
    }
  };

  return (
    <div className={classes.container}>
      <Box className={classes.header}>
        <VideoLibrary className={classes.icon} />
        <Typography variant="h3" className={classes.title}>
          Ajouter une vidéo
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          Téléversez une nouvelle vidéo pour votre laboratoire
        </Typography>
      </Box>

      <Paper className={classes.card} elevation={0}>
        <Box className={classes.formSection}>
          <TextField
            label="Nom de la vidéo"
            fullWidth
            onChange={(e) => setFileName(e.target.value)}
            variant="outlined"
            placeholder="Ex: Vidéo d'attente enfants"
          />
        </Box>

        <Box className={classes.formSection}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="select-sex-label">Sexe</InputLabel>
            <Select
              labelId="select-sex-label"
              id="select-sex"
              value={sex}
              onChange={(e) => setSex(e.target.value)}
              label="Sexe"
            >
              <MenuItem value="h">Homme</MenuItem>
              <MenuItem value="f">Femme</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box className={classes.formSection}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Âge minimum"
                type="number"
                onChange={(e) => setMinAge(e.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Âge maximum"
                type="number"
                onChange={(e) => setMaxAge(e.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={classes.formSection}>
          <Box className={classes.uploadZone} onClick={fileSelectionClick}>
            <CloudUpload className={classes.uploadIcon} />
            <Typography
              variant="h6"
              style={{ marginBottom: 8, fontWeight: 500 }}
            >
              {file ? file.name : "Cliquez pour sélectionner une vidéo"}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              MP4 ou MOV • Maximum 35 MB
            </Typography>
            <input
              type="file"
              hidden
              accept="video/mp4, video/mov"
              ref={selectFile}
              onChange={(e) => {
                if (e.target.files[0].size > 35000000) {
                  enqueueSnackbar("Fichier trop lourd, maximum 35 MB.", {
                    variant: "error",
                  });
                  return;
                }
                setFile(e.target.files[0]);
              }}
              onClick={(e) => {
                e.target.value = null;
              }}
            />
          </Box>
        </Box>

        <Box className={classes.formSection}>
          <FormControlLabel
            control={
              <Checkbox
                checked={disclaimer}
                onChange={(e) => setDisclaimer(e.target.checked)}
                color="primary"
              />
            }
            label="Je certifie que cette vidéo a été obtenue de façon licite et provient d'une source fiable"
          />
        </Box>

        {upload && (
          <Box className={classes.progressContainer}>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: 8 }}
            >
              Upload en cours... {progress}%
            </Typography>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        )}

        {progress === 100 && (
          <Box className={classes.successMessage}>
            <CheckCircle />
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              Vidéo téléversée avec succès !
            </Typography>
          </Box>
        )}

        {!upload && (
          <Box style={{ marginTop: 24 }}>
            <CustomButton
              title="Téléverser la vidéo"
              onClick={submit}
              fullWidth
            />
          </Box>
        )}
      </Paper>
    </div>
  );
}
